import styled from 'styled-components';
import { EmptyStateEmbedded } from 'ui/illustrations';
import { body2, colors, spacing } from 'ui/theme';

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const PlacementPromptContainer = styled.div`
  display: flex;
  gap: ${spacing.base};
  position: relative;
`;

export const PlacementPromptContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const SecondaryText = styled.span`
  ${body2}
  color: ${colors.textSecondary};
`;

export const StyledIllustration = styled(EmptyStateEmbedded)`
  position: relative;
  top: -${spacing.base};
`;

export const StyledLink = styled.a`
  display: flex;
  gap: ${spacing.threeQuarter};
`;
